import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { Button, Modal } from 'antd';
import uniqBy from 'lodash/uniqBy';

import { StickyContainer, Sticky } from 'react-sticky';


import { round } from 'lodash';
import { api } from '../../../services';

import { AlarmsCard, CarCard, ClientCard, CommunicationCard, DTCsCard, IssuesCard, LeadCard, MaintenanceCard, NoteCard, ReservationsCard, HealtCarCard, TicketCard } from './cards';
import Actions from './Actions';

import './Carview.css';
import { inject, observer } from 'mobx-react';
import moment from 'moment';

const normalizeBattery = battery => {
  if (battery) {
    battery.value = round(battery.value / 1000, 1);
  }
  return battery;
};

const getPassedTicketId = () =>{
  var params = new URLSearchParams(window.location.search);
  if (params.has("ticketId")) {
    return params.get("ticketId");
  }
  return -1;
}

@withRouter
@inject('translationsStore', 'commonStore', 'carsStore', 'authStore')
@observer
export class Carview extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loadingCar: false,
      loadingLead: false,
      finishLoading: false,
      car: {},
      clientCardTop: -1,
      carCardTop: -1,
      loadingObdService: false,
      loadingTicket: false,
      loadingDTCScanService: false,
      config: {}
    };

    this.passedTicketId = getPassedTicketId();
    this.clientRef = React.createRef();
    this.carRef = React.createRef();
    this.anchorRefs = {
      communications: React.createRef(),
      leads: React.createRef(),
      alarms: React.createRef(),
      dtcs: React.createRef()
    };
  }

  componentDidMount() {
    api('dealer profile').then(dealer => {
      this.props.commonStore.setDealer(dealer);
    });
    window.scrollTo(0, 0);
    this.loadCarview();
    document.addEventListener('scroll', this.trackScrolling);

    this.handleScrollFragment();
  }

  componentWillUpdate() {
    this.handleScrollFragment();
  }

  handleScrollFragment = () => {
    // const element = document.getElementById(id);
    if (typeof window.location.hash === 'string' && window.location.hash.length > 1) {
      const element = document.getElementById(window.location.hash.slice(1));
      if (element) {
        // !null
        const ref = Object.values(this.anchorRefs).find(item => item.firstChild.id === element.id);
        ref.scrollIntoView({
          behaviour: 'smooth',
          block: 'center',
          inline: 'center'
        });
      }
    }
  };

  isBottom(el) {
    return el.getBoundingClientRect().bottom <= window.innerHeight;
  }

  componentWillUnmount() {
    document.removeEventListener('scroll', this.trackScrolling);
  }

  trackScrolling = () => {
    const wrappedElement = document.getElementById('Carview');
    if (this.isBottom(wrappedElement)) {
      this.setState({ bottomReached: true });
    } else {
      if (this.state.bottomReached) {
        this.setState({ bottomReached: false });
      }
    }
  };

  loadCarConfig() {
    this.setState({ loadingObdService: true });
    api('get car config', this.props.match.params.carId)
      .then(config => {
        this.setState({ config, loadingObdService: false });
      })
      .catch(() => {
        this.setState({ loadingObdService: false });
      });
  }

  loadCarMaintenaces = () => {
    const { car } = this.state;
    return api('getMaintenances', car.id).then(maintenances => {
      if (maintenances && maintenances.length > 0) {
        let mileage;
        if (car.odometer && car.odometer.value) {
          mileage = car.odometer.value;
        } else if (car.gpsOdometer && car.gpsOdometer.value) {
          mileage = car.gpsOdometer.value + car.initialOdometer;
        }
        if (mileage) {
          maintenances = maintenances.map(m => Object.assign(m, { mileage: Math.round(mileage) }));
        }
      }
      const nextFactoryMaintenance = maintenances
        .filter(maintenance => !maintenance.custom)
        .filter(maintenance => moment(maintenance.virtualDate).isAfter(moment()))
        .sort((a, b) => (moment(a.virtualDate).isAfter(b.virtualDate) || !b.virtualDate ? 1 : moment(a.virtualDate).isBefore(b.virtualDate) || !a.virtualDate ? -1 : 0))
        .shift();
      const allNextCustomMaintenance = maintenances.filter(maintenance => maintenance.custom);
      const maintenancesFromUnmanagedLeads = maintenances.filter(maintenance => !!maintenance.leadId && !maintenance.performed);
      maintenances = [nextFactoryMaintenance]
        .concat(allNextCustomMaintenance, maintenancesFromUnmanagedLeads)
        .sort((a, b) => (moment(a.virtualDate).isAfter(b.virtualDate) ? 1 : moment(a.virtualDate).isBefore(b.virtualDate) ? -1 : 0))
        .filter(maintenance => maintenance !== undefined);
      maintenances = uniqBy(maintenances, 'id');
      this.shuffledCarMaintenances(car, maintenances);
    });
  };

  shuffledCarMaintenances = (car, maintenances) => {
    const othermaintenances = maintenances.splice(2);
    this.setState({ maintenances: maintenances.splice(0, 2), othermaintenances });
  };

  loadCarview = () => {
    this.setState({ loadingCar: true, loadingLead: true });
    api('getCar', this.props.match.params.carId)
      .then(async car => {
        const { client, lastNoteDate, id: carId, subscriptionStart, subscriptionEnd } = car;
        const { fuelLevel, coolerTemp, battery, odometer, oilLevel, gpsOdometer, ignitionState, ignitionStateUpdatedAt, initialOdometer } = car; //healthStatus
        this.setState({
          car,
          loadingCar: false,
          lastNoteDate,
          client: { ...client, subscriptionStart, subscriptionEnd },
          carId,
          healthStatus: { fuelLevel, coolerTemp, battery: normalizeBattery(battery), odometer, oilLevel, gpsOdometer, ignitionState, ignitionStateUpdatedAt, initialOdometer }
        });

        this.loadCarConfig();
        this.loadDTCFullScanStatus();

        await this.loadCarMaintenaces();

        const p1 = api('get fidelity', client.id)
          .then(fidelity => fidelity)
          .catch(() => ({ total: 0, booked: 0, suspended: 0, discarded: 0, fidelityIndex: 0 }))
          .then(fidelity => {
            this.setState({ client: { ...this.state.client, fidelity } });
          });

        const p2 = api('getLead', this.props.match.params.carId)
          .then(lead => ({ lead }))
          .catch(error => ({ error }))
          .then(({ lead }) => {
            this.setState({ loadingLead: false });
            if (lead && lead.id) {
              const { id: leadId } = lead;
              this.setState({ lead, otherreservations: lead.reservations.splice(1), reservations: lead.reservations.splice(0, 1), leadId });

              const p1 = api('getDtcs', leadId)
                .then(dtcs =>
                  dtcs.sort((d1, d2) => {
                    if (d1.severity === 'red' && d2.severity === 'orange') {
                      return -1;
                    }
                    if (d1.severity === 'orange' && d2.severity === 'red') {
                      return 1;
                    }
                    return 0;
                  })
                )
                .then(dtcs => {
                  const otherdtcs = dtcs.splice(2);
                  this.setState({ dtcs: dtcs.splice(0, 2), otherdtcs });
                });

              const p2 = api('getAlarms', leadId)
                .then(alarms => alarms.filter(alarm => alarm.present === true))
                .then(alarms =>
                  alarms.sort((a1, a2) => {
                    if (a1.safety === true && (!a2.safety || a2.safety === false)) {
                      return -1;
                    }
                    if ((!a1.safety || a1.safety === false) && a2.safety === true) {
                      return 1;
                    }
                    return 0;
                  })
                )
                .then(alarms => {
                  const otheralarms = alarms.splice(2);
                  this.setState({ alarms: alarms.splice(0, 2), otheralarms });
                });

              const p3 = api('getCommunicationsByLead', leadId).then(communications => {
                const othercommunications = communications.splice(3);
                this.setState({ communications: communications.splice(0, 3), othercommunications });
              });

              return Promise.all([p1, p2, p3]);
            }
          });

        return Promise.all([p1, p2]);
      })
      .catch(error => ({ error }))
      .then(() => {
        this.setState({ finishLoading: true, clientCardTop: this.clientRef.current.getClientRects()[0].top, carCardTop: this.carRef.current.getClientRects()[0].top });
      });
  }

  componentDidUpdate(prevProps) {
    if (prevProps.location.pathname !== this.props.location.pathname) {
      this.loadCarview();
    }
  }

  afterSendNote = result => {
    if (result.success === true) {
      this.setState({ lastNoteDate: result.lastNoteDate });
    }
  };

  reloadLead = () => {
    this.setState({ loadingLead: true });
    api('getLead', this.props.match.params.carId).then(lead => {
      this.setState({
        loadingLead: false,
        lead,
        otherreservations: lead.reservations.splice(1),
        reservations: lead.reservations.splice(0, 1)
      });
    });
  };

  changeObdService = service => {
    const { car, loadingObdService } = this.state;
    if (!loadingObdService) {
      this.setState({ loadingObdService: true });
      api('set obd service', car.id, service)
        .then(result => {
          if (result.success === false) {
            Modal.error({ title: this.props.translationsStore.translate('carView.shutdownCallError'), content: result.message });
          }
          this.loadCarConfig();
        })
        .catch(error => {
          Modal.error({ title: this.props.translationsStore.translate('carView.shutdownCallError'), content: error });
          this.loadCarConfig();
        });
    }
  };

  setDTCFullScanStatusInterval = () => {
    const { car } = this.state;

    if (!!car.lastDTCScanResponse && !!car.lastDTCScanResponse.status && car.lastDTCScanResponse.status === "CREATED") {
      setTimeout(() => {
        this.loadDTCFullScanStatus();
      }, 30000);
    }
  };

  launchDTCFullScan = () => {
    const { car } = this.state;

    api('launch dtc full scan', car.id)
      .then(result => {
        if (!!result && !!result.lastDTCScanResponse && !! result.lastDTCScanResponse.message) {
          Modal.error({ title: this.props.translationsStore.translate('carView.dtcscanservice.launch.error'), content: result.lastDTCScanResponse.message });
        } else {
          this.setState({ car: { ...car, lastDTCScanResponse: result.lastDTCScanResponse } },
            () => this.setDTCFullScanStatusInterval());

          Modal.info({
            title: this.props.translationsStore.translate(`carView.dtcscanservice.launch.inprogress.title`),
            content: (
              <div>
                <div>{this.props.translationsStore.translate(`carView.dtcscanservice.launch.inprogress.content`)}</div>
              </div>
            )
          });
        }
      })
      .catch(error => {
        Modal.error({ title: this.props.translationsStore.translate('carView.dtcscanservice.launch.error'), content: error });
      });
  };

  loadDTCFullScanStatus = () => {
    const { car } = this.state;

    if (!!car.lastDTCScanResponse && !!car.lastDTCScanResponse.status && car.lastDTCScanResponse.status === "CREATED") {
      api('get dtc full scan status', car.id)
        .then(result => {
          if (!!result && !!result.lastDTCScanResponse && !! result.lastDTCScanResponse.message) {
            console.log("loadDTCFullScanStatus error: " + message);
          } else {
            this.setState({ car: { ...car, lastDTCScanResponse: result.lastDTCScanResponse } },
              () => this.setDTCFullScanStatusInterval());
          }
        })
        .catch(error => {
          console.log("loadDTCFullScanStatus error: " +error);
        });
    }
  };

  goBackToSearch = () => {
    const backList = ['carlist'];
    if (backList.find(element => this.props.history.location.search.indexOf(element) > -1) !== undefined) {
      this.props.history.goBack();
    } else {
      this.props.history.push('/dashboard');
    }
  };

  deleteVehicle = () => {
    api('deleteCar', this.state.carId)
      .then(() => {
        Modal.success({
          title: this.props.translationsStore.translate('carView.DeleteVehicle.success.title'),
          content: this.props.translationsStore.translate('carView.DeleteVehicle.success.content'),
          onOk: () => {
            this.goBackToSearch();
          }
        });
      })
      .catch(() => {
        Modal.error({
          title: this.props.translationsStore.translate('carView.DeleteVehicle.error.title'),
          content: this.props.translationsStore.translate('carView.DeleteVehicle.error.content')
        });
      });
  };

  openDeleteVehicleModal = () => {
    Modal.confirm({
      title: this.props.translationsStore.translate('carView.DeleteVehicle.modal.title'),
      content: this.props.translationsStore.translate('carView.DeleteVehicle.modal.content'),
      onOk: () => {
        this.deleteVehicle();
      }
    });
  };

  render() {
    const { commonStore, authStore } = this.props;
    const { config, loadingObdService, loadingDTCScanService } = this.state;
    const { car, client } = this.state;

    return (
      <div className="Carview" id="Carview">
        <StickyContainer>
          <Sticky>
            {({ style, isSticky }) => {
              return (
                <div style={style} className={`sticky ${isSticky ? 'isSticky' : ''}`}>
                  <div style={{ display: 'flex' }}>
                    <Button icon="left" className="reverse" type="primary" onClick={this.goBackToSearch}>
                      {this.props.translationsStore.translate('carView.back')}
                    </Button>
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                      {!!client && <span>{client.fullName}</span>}
                      {!!client && (!!car.make || !!car.model) && <span>&nbsp;&nbsp;</span>}
                      {!!car && !!car.make && <span>{car.make.descrizione}</span>}
                      {!!car && !!car.model && <span>{car.model.descrizione}</span>}
                    </div>
                  </div>
                  <TicketCard
                  carId={this.state.carId}
                  style={{ margin: '16px 0' }}
                  ticketId={this.passedTicketId}
                  />
                </div>
              );
            }}
          </Sticky>

          <div id="ClientCarContainer">
            <div className="Col1" id="Client" ref={this.clientRef}>
              <ClientCard style={{ marginBottom: '16px' }} {...this.state.client} />
              <div
                ref={ref => {
                  this.anchorRefs.leads = ref;
                }}
              >
                <LeadCard style={{ margin: '16px 0' }} carId={car && car.id} {...this.state.lead} />
              </div>
              <ReservationsCard
                style={{ margin: '16px 0' }}
                carId={this.state.carId}
                leadId={this.state.leadId}
                reservations={this.state.reservations}
                otherreservations={this.state.otherreservations}
                loading={this.state.loadingLead}
                onChange={this.reloadLead}
              />
              <div
                ref={ref => {
                  this.anchorRefs.communications = ref;
                }}
              >
                <CommunicationCard
                  style={{ margin: '16px 0' }}
                  carId={this.state.carId}
                  lead={this.state.lead}
                  communications={this.state.communications}
                  othercommunications={this.state.othercommunications}
                />
              </div>
              <NoteCard
                style={{ margin: '16px 0' }}
                carId={this.state.carId}
                lastNoteDate={this.state.lastNoteDate}
                loading={this.state.loadingCar}
                afterSendNote={this.afterSendNote}
              />
              <MaintenanceCard
                carId={this.state.carId}
                maintenances={this.state.maintenances}
                othermaintenances={this.state.othermaintenances}
                style={{ margin: '16px 0' }}
                onConfirmMaintenances={this.loadCarMaintenaces}
              />
            </div>
            <div className="Col2" id="Car" ref={this.carRef}>
              <CarCard
                style={{ marginBottom: '16px' }}
                {...this.state.car}
                obdService={{ ...config.obdService, loading: loadingObdService }}
                offer={{ ...config.offer }}
                onChangeObdService={this.changeObdService}
                onLaunchDTCFullScan={this.launchDTCFullScan}
              />
              <HealtCarCard style={{ margin: '16px 0' }} {...this.state.healthStatus} carId={this.state.carId} />
              <IssuesCard
                style={{ margin: '16px 0' }}
                alarms={this.state.alarms}
                dtcs={[...(this.state.dtcs || []), ...(this.state.otherdtcs || [])]}
                lastConnection={this.state.car.lastConnection}
                kmPerDay={this.state.car.kmPerDay}
                status={this.state.car.status}
                shutdown={config.obdService ? config.obdService.current === 'shutdown' : null}
                obdService={{ ...config.obdService, loading: loadingObdService }}
                offer={config.offer ? (config.offer.status === 'success' && config.offer.name === 'Full' && config.obdService.current === 'active' ? 'full' : 'safe') : undefined}
                carId={this.state.carId}
                serviceLevel={this.state.car.serviceLevel}
              />
              <div
                ref={ref => {
                  this.anchorRefs.alarms = ref;
                }}
              >
                <AlarmsCard style={{ margin: '16px 0' }} alarms={this.state.alarms} otheralarms={this.state.otheralarms} serviceLevel={this.state.car.serviceLevel}/>
              </div>
              <div
                ref={ref => {
                  this.anchorRefs.dtcs = ref;
                }}
              >
                <DTCsCard style={{ margin: '16px 0' }} dtcs={this.state.dtcs} otherdtcs={this.state.otherdtcs} serviceLevel={this.state.car.serviceLevel}/>
              </div>
            </div>
          </div>
          {authStore.isAdmin && (
            <div>
              <Button type="warning" className="deleteVehicle" onClick={this.openDeleteVehicleModal}>
                {this.props.translationsStore.translate('carView.DeleteVehicle.button')}
              </Button>
            </div>
          )}
          <div className={`sticky-footer ${this.state.bottomReached ? 'bottomReached' : ''}`}>
            <Actions carId={this.state.carId} lead={this.state.lead} onChange={this.loadCarview} client={this.state.client} dealer={commonStore.dealer} />
          </div>
        </StickyContainer>
      </div>
    );
  }
}

export default Carview;
